import { axiosInstance } from "../../../utils/AxiosInstance/AxiosInstance";

// To be create and used later in admin quotation page.
export const fetchAllQuotationVersionByQuotationId = async (quotationId) => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/all-quotation-version/${quotationId}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to create or update organization setup');
    }
}

export const downloadQuotationPdf = async (data) => {
    try {

        const response = await axiosInstance.post(`/api/v2/common/quotation/download-quotation-pdf`, data);


        return response;
    } catch (error) {
        console.error('Error downloading PDF:', error);
        throw new Error('Failed to download the quotation PDF. Please try again later.');
    }
};



export const deleteQuotationById = async (quoteId) => {
    try {
        let response = await axiosInstance.delete(`/api/v2/common/quotation/delete/${quoteId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting quotation:', error);
        throw new Error('Failed to delete quotation. Please try again later.');
    }
};

export const getQuotePartsDataById = async (quoteId, type) => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/quotation/get-quote-parts-data/${quoteId}?type=${type}`);
        return response.data;

    } catch (error) {
        console.error('Error deleting quotation:', error);
        throw new Error('Failed to delete quotation. Please try again later.');
    }
}
export const updateVersionName = async (quoteId, data) => {
    console.log("Data going ::", quoteId, data);
    try {
        const response = await axiosInstance.post(`/api/v2/common/quotation/update-version-quote/${quoteId}`, data);
        return response.data;

    } catch (error) {
        console.error('Error deleting quotation:', error);
        throw new Error('Failed to delete quotation. Please try again later.');
    }
}
export const fetchQuoteData = async (quoteId, token, isLoggedIn, isAdmin) => {
    try {
        const response = await axiosInstance.get(
            `comman/fetch-quote-byId/${quoteId}?isLoggedIn=${isLoggedIn}&isAdmin=${isAdmin}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching quotation:", error);
        throw new Error("Failed to fetch quotation. Please try again later.");
    }
};